import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ISchedulerDto, ISchedulerResponse, SchedulerField } from "../models/scheduler.model";
import { EnvironmentService } from "../services/environment.service";

@Injectable({
    providedIn: "root"
})
export class SchedulerApiService {
    constructor(private environmentService: EnvironmentService, private httpClient: HttpClient) {}

    getSchedulers(page: number, fields: SchedulerField[], filter?: string, sort?: string): Observable<ISchedulerResponse> {
        let httpParams = new HttpParams();
        httpParams = httpParams.set("page", page + "");
        httpParams = httpParams.set("fields", fields.join(","));
        if (filter) httpParams = httpParams.set("filter", filter);

        if (sort) httpParams = httpParams.set("sort", sort);

        return this.httpClient.get<ISchedulerResponse>(`${this.environmentService.apiUrl}/scheduler`, { params: httpParams });
    }

    addScheduler(scheduler: ISchedulerDto) {
        return this.httpClient.post(`${this.environmentService.apiUrl}/scheduler`, scheduler);
    }

    editScheduler(schedulerId: string, scheduler: ISchedulerDto) {
        return this.httpClient.put(`${this.environmentService.apiUrl}/scheduler/${schedulerId}`, scheduler);
    }

    deleteScheduler(schedulerId: string) {
        return this.httpClient.delete(`${this.environmentService.apiUrl}/scheduler/${schedulerId}`);
    }
}
